import script from "./OrgOrderReqList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrderReqList.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrderReqList.vue?vue&type=style&index=0&id=323bb250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323bb250"]])

export default __exports__